import React, {useEffect, useState, useContext} from 'react'
import DivLayout from 'components/sales/divLayout/divLayout';
import Layout from 'components/sales/layout/layout';
import localization from "../../../assets/localization/localization";
import { Button } from 'react-bootstrap';
import CustomModal from "../../valetServices/modal";
import ModalPop from 'components/sales/modal/modal';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import {toast} from "react-toastify";
import DocumentView from 'components/sales/downloadDocView/documentView';
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const ViewListing = ({
                         viewMaterial,
                         viewMaterialDetails,
                         match,
                         MrfApproval,
                         materialApprovalDetails,
                         history
                     }) => {

    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [count, setCount] = useState(0)
    const [isModal, setIsModal] = useState(false);
    const [approvalStatus, setApprovalStatus] = useState(0);
    const [remarks, setRemarks] = useState("");
    const [showModalContent, setShowModalContent] = useState(true)

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await viewMaterial(match?.params?.id, match?.params?.list_type)
            setIsLoading(false);
        })()
    }, [])

    const setStatus = (status) => {
        setIsModal(true)
        setApprovalStatus(status)
    }

    const handleApprovalOrRejection = async () =>{

        let isBroken = false;
        if(remarks === ""){
            toast.error("Remark is required");
            isBroken = true
        }

        if (isBroken) {
            return false
        }

        setShowModalContent(false)
        const params = {
            mrf_id:match?.params?.id,
            approval_status:approvalStatus,
            remark:remarks
        }
        setIsLoading(true)
        await MrfApproval(params)
        setIsLoading(false)
        setCount(count + 1)
        setIsModal(false)
        setShowModalContent(true)
    }

    return (
        <Layout
            title={localization.BacktoList}
            isGoback
            isLoading={isLoading}
        >
            {viewMaterialDetails
                ?
                <>
                    <div className="panel-card card-details" width="100%">

                        {materialApprovalDetails !== null && materialApprovalDetails?.response?.status !== 200 &&
                            <CustomModal msg={materialApprovalDetails?.response?.message} click={count} history={history} url={`${baseUrl}/mrf-approval-listing/1`}/>}
                        {materialApprovalDetails !== null && materialApprovalDetails?.response?.status === 200 &&
                            <CustomModal msg={materialApprovalDetails?.response?.message} isPageLoad={true} history={history} url={`${baseUrl}/mrf-approval-listing/1`} click={count}/>}

                        <div className="panel-heading">{localization.materialDetails}</div>
                        <div className="panel-body">
                            <div className="details-listing detail_alignment">
                                <DivLayout
                                    heading={"MRF Id"}
                                    data={
                                        viewMaterialDetails?.id
                                    }
                                />
                                {viewMaterialDetails?.rm_ticket_id &&
                                    <DivLayout
                                        heading={localization.fusion_ticket_id}
                                        data={
                                            viewMaterialDetails?.rm_ticket_id
                                        }
                                    />
                                }
                                {viewMaterialDetails?.to_employee_type?.name &&
                                    <DivLayout
                                        heading={localization.to}
                                        data={
                                            viewMaterialDetails?.to_employee_type?.name
                                        }
                                    />
                                }
                                <DivLayout
                                    heading={localization.SiteNo}
                                    data={
                                        viewMaterialDetails?.site?.site_no
                                    }
                                />

                                {viewMaterialDetails?.from_site?.lead?.client_name &&
                                    <DivLayout
                                        heading={localization.fromSite}
                                        data={
                                            viewMaterialDetails?.from_site?.lead?.client_name
                                        }
                                    />
                                }

                                {viewMaterialDetails?.warehouse_address?.company_name &&
                                    <DivLayout
                                        heading={localization.store}
                                        data={
                                            viewMaterialDetails?.warehouse_address?.company_name
                                        }
                                    />
                                }

                                {viewMaterialDetails?.planned_delivery_date &&
                                    <DivLayout
                                        heading={localization.plannedDeliveryDate}
                                        data={
                                            viewMaterialDetails?.planned_delivery_date
                                        }
                                    />
                                }

                                {viewMaterialDetails?.invoice_no &&
                                    <DivLayout
                                        heading={localization.invoiceNo}
                                        data={
                                            viewMaterialDetails?.invoice_no
                                        }
                                    />
                                }
                                {viewMaterialDetails?.payment_received &&
                                    <DivLayout
                                        heading={localization.paymentReceived}
                                        data={
                                            viewMaterialDetails?.payment_received
                                        }
                                    />
                                }
                                {viewMaterialDetails?.scope &&
                                    <DivLayout
                                        heading={localization.scope}
                                        data={
                                            viewMaterialDetails?.scope
                                        }
                                    />
                                }
                                {viewMaterialDetails?.mrf_flow &&
                                    <DivLayout
                                        heading={localization.flow}
                                        data={
                                            viewMaterialDetails?.mrf_flow
                                        }
                                    />
                                }
                                {viewMaterialDetails?.po_number &&
                                    <DivLayout
                                        heading={localization.poNo}
                                        data={
                                            viewMaterialDetails?.po_number
                                        }
                                    />
                                }
                                
                                {viewMaterialDetails?.material_service_type &&
                                    <DivLayout
                                        heading={localization.materialsServiceType}
                                        data={
                                            viewMaterialDetails?.material_service_type
                                        }
                                    />
                                }
                                {viewMaterialDetails?.created_by &&
                                    <DivLayout
                                        heading={localization.createdBy}
                                        data={
                                            viewMaterialDetails?.created_by?.name
                                        }
                                    />
                                }
                                {viewMaterialDetails?.employee_type &&
                                    <DivLayout
                                        heading={localization.employeeName}
                                        data={
                                            viewMaterialDetails?.employee_type?.name
                                        }
                                    />
                                }
                                {viewMaterialDetails?.material_acquisition_type?.name &&
                                    <DivLayout
                                        heading={localization.materialTypes}
                                        data={
                                            viewMaterialDetails?.material_acquisition_type?.name
                                        }
                                    />
                                }
                                {viewMaterialDetails?.am?.name &&
                                    <DivLayout
                                        heading={localization.AM}
                                        data={
                                            viewMaterialDetails?.am?.name
                                        }
                                    />
                                }
                                {viewMaterialDetails?.asm?.name &&
                                    <DivLayout
                                        heading={localization.ASM}
                                        data={
                                            viewMaterialDetails?.asm?.name
                                        }
                                    />
                                }
                                {viewMaterialDetails?.warehouse_address?.company_name &&
                                    <DivLayout
                                        heading={localization.slocWarehouse}
                                        data={
                                            viewMaterialDetails?.warehouse_address?.company_name + "(" + viewMaterialDetails?.warehouse_address?.geo_city.city_name + ")"
                                        }
                                    />
                                }
                                {viewMaterialDetails?.site?.lead?.client_name &&
                                    <DivLayout
                                        heading={localization.toClientName}
                                        data={
                                            viewMaterialDetails?.site?.lead?.client_name
                                        }
                                    />
                                }
                                {viewMaterialDetails?.site?.lead?.lead_type?.name &&
                                    <DivLayout
                                        heading={localization.businessName}
                                        data={
                                            viewMaterialDetails?.site?.lead?.lead_type?.name
                                        }
                                    />
                                }
                                {viewMaterialDetails?.site?.lead?.lead_commercial_details?.lead_commercial_type?.name &&
                                    <DivLayout
                                        heading={localization.commercialType}
                                        data={
                                            viewMaterialDetails?.site?.lead?.lead_commercial_details?.lead_commercial_type?.name
                                        }
                                    />
                                }
                                {viewMaterialDetails?.remarks &&
                                    <DivLayout
                                        heading={localization.remarkForStore}
                                        data={
                                            viewMaterialDetails?.remarks
                                        }
                                    />
                                }

                                {viewMaterialDetails?.remark_for_approver &&
                                    <DivLayout
                                        heading={localization.remarkForApprover}
                                        data={
                                            viewMaterialDetails?.remark_for_approver
                                        }
                                    />
                                }
                                {viewMaterialDetails?.mode_of_transport &&
                                    <DivLayout
                                        heading={localization.modeOfTransport}
                                        data={
                                            viewMaterialDetails?.mode_of_transport
                                        }
                                    />
                                }
                                {viewMaterialDetails?.invoice_amount &&
                                    <DivLayout
                                        heading={localization.invoiceAmount}
                                        data={
                                            viewMaterialDetails?.invoice_amount
                                        }
                                    />
                                }

                                {viewMaterialDetails?.cheque_utr_no !== '' && viewMaterialDetails?.cheque_utr_no !== null &&
                                    <DivLayout
                                        heading={localization.chequeUTRNo}
                                        data={
                                            viewMaterialDetails?.cheque_utr_no
                                        }
                                    />
                                }

                                {viewMaterialDetails?.cheque_utr_date !== '' && viewMaterialDetails?.cheque_utr_date !== null &&
                                    <DivLayout
                                        heading={localization.chequeUTRDate}
                                        data={
                                            viewMaterialDetails?.cheque_utr_date
                                        }
                                    />
                                }

                                {viewMaterialDetails?.cheque_utr_photo !== '' && viewMaterialDetails?.cheque_utr_photo !== null &&
                                    <DocumentView
                                        title={localization.chequeUTRPhoto}
                                        attachment={viewMaterialDetails?.cheque_utr_photo}
                                    />
                                }

                                {viewMaterialDetails?.material_acq_history_approval &&
                                    viewMaterialDetails?.material_acq_history_approval.map((val, i) => {
                                        return (
                                            <>
                                                <DivLayout
                                                    heading={localization.remarksBy+"("+val?.action_person?.name+")"}
                                                    data={
                                                        val.remark
                                                    }
                                                />
                                            </>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    {viewMaterialDetails?.all_challans_details_for_mrf && viewMaterialDetails?.all_challans_details_for_mrf?.length > 0 &&
                        <>
                            <div className="panel-card card-details">
                                <div className="panel-heading">{localization.shipments}</div>
                                <div className="panel-body">
                                    <div className="details-listing detail_alignment">
                                        <table className="table table-striped">
                                            <thead>
                                            <tr>
                                                <th>Transfer Shipment No.</th>
                                                <th>Shipment Date</th>
                                                <th>Delivery Challan</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {viewMaterialDetails?.all_challans_details_for_mrf.map((val) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>{val?.transfer_shipment_no}</td>
                                                            <td>{val?.created_at}</td>
                                                            <td>
                                                            <DocumentView
                                                                title={`Delivery Challan`}
                                                                attachment={val?.delivery_challan_from_erp} 
                                                            />
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {viewMaterialDetails?.material_acquisition_line_items &&
                        <>
                            <div className="panel-card card-details">
                                <div className="panel-heading">{localization.materialAcquisitionLineItems}</div>
                                <div className="panel-body">
                                    <div className="details-listing detail_alignment">
                                        <table className="table table-striped">
                                            <thead>
                                            <tr>
                                                <th>Brand</th>
                                                <th>Name</th>
                                                {/* <th>Description</th> */}
                                                <th>Specification</th>
                                                <th>Material Code</th>
                                                <th>Quantity</th>
                                                <th>Inventories</th>
                                                <th>Sale Value</th>
                                                <th style={{color:"red"}}>Returnable</th>
                                                {viewMaterialDetails?.material_type_id !== undefined && parseInt(viewMaterialDetails?.material_type_id) === 28 &&
                                                    <>
                                                        <th>From Tag</th>
                                                        <th>To Tag</th>
                                                    </>
                                                }
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {viewMaterialDetails?.material_acquisition_line_items.map((val) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>{val?.materials?.brand?.name}</td>
                                                            <th>{JSON.parse(val?.material_details)['name']}</th>
                                                            <td>{val?.specification}</td>
                                                            {/* <th>{JSON.parse(val?.material_details)['description']}</th> */}
                                                            <th>{val?.material_code}</th>
                                                            <th>{val?.quantity}</th>
                                                            <th>{val?.inventories}</th>
                                                            <th>{val?.sale_value}</th>
                                                            <th style={{color:"red"}}>
                                                                {parseInt(val?.refundable) === 1 ? "Yes" : "No"}
                                                            </th>
                                                            {viewMaterialDetails?.material_type_id !== undefined && parseInt(viewMaterialDetails?.material_type_id) === 28 &&
                                                                <>
                                                                    <th>{val?.from_tags}</th>
                                                                    <th>{val?.to_tags}</th>
                                                                </>
                                                            }
                                                        </tr>
                                                    </>
                                                )
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {viewMaterialDetails?.shipping_address && viewMaterialDetails?.shipping_address !== null  &&
                        <>
                            <div className="panel-card card-details" width="100%">
                                <div className="panel-heading">{localization.shippedTo}</div>
                                <div className="panel-body">
                                    <div className="details-listing detail_alignment">
                                        <DivLayout
                                            heading={localization.contactName}
                                            data={
                                                JSON.parse(viewMaterialDetails?.shipping_address?.details)['contact_name']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.phoneNumber}
                                            data={
                                                JSON.parse(viewMaterialDetails?.shipping_address?.details)['contact_number']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.email}
                                            data={
                                                JSON.parse(viewMaterialDetails?.shipping_address?.details)['contact_email']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.state}
                                            data={
                                                JSON.parse(viewMaterialDetails?.shipping_address?.details)['state']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.city}
                                            data={
                                                JSON.parse(viewMaterialDetails?.shipping_address?.details)['city']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.pinCode}
                                            data={
                                                JSON.parse(viewMaterialDetails?.shipping_address?.details)['pincode']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.address1}
                                            data={
                                                JSON.parse(viewMaterialDetails?.shipping_address?.details)['address']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.address2}
                                            data={
                                                JSON.parse(viewMaterialDetails?.shipping_address?.details)['address2']
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {viewMaterialDetails?.shipping_address && viewMaterialDetails?.billing_address !== null  &&
                        <>
                            <div className="panel-card card-details" width="100%">
                                <div className="panel-heading">{localization.billedTo}</div>
                                <div className="panel-body">
                                    <div className="details-listing detail_alignment">
                                        <DivLayout
                                            heading={localization.contactName}
                                            data={
                                                JSON.parse(viewMaterialDetails?.billing_address?.details)['contact_name']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.phoneNumber}
                                            data={
                                                JSON.parse(viewMaterialDetails?.billing_address?.details)['contact_number']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.email}
                                            data={
                                                JSON.parse(viewMaterialDetails?.billing_address?.details)['contact_email']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.state}
                                            data={
                                                JSON.parse(viewMaterialDetails?.billing_address?.details)['state']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.city}
                                            data={
                                                JSON.parse(viewMaterialDetails?.billing_address?.details)['city']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.pinCode}
                                            data={
                                                JSON.parse(viewMaterialDetails?.billing_address?.details)['pincode']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.address1}
                                            data={
                                                JSON.parse(viewMaterialDetails?.billing_address?.details)['address']
                                            }
                                        />
                                        <DivLayout
                                            heading={localization.address2}
                                            data={
                                                JSON.parse(viewMaterialDetails?.billing_address?.details)['address2']
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {viewMaterialDetails?.material_type_id === 3 && viewMaterialDetails?.mrf_flow === "Normal Flow" && viewMaterialDetails?.advance_pick === "Yes"  
                    &&
                        <>
                            <div className="panel-card card-details" width="100%">
                                <div className="panel-heading">{localization.paymentPortal}</div>
                                <div className="panel-body">
                                    <div className="details-listing detail_alignment">
                                        <DivLayout
                                            heading={localization.paymentMode}
                                            data={viewMaterialDetails?.advance_payment[0]?.payment_mode}
                                        />
                                        <DivLayout
                                            heading={localization.transAmount}
                                            data={viewMaterialDetails?.advance_payment[0]?.trans_amount}
                                        />
                                        <DivLayout
                                            heading={localization.referenceNumber}
                                            data={viewMaterialDetails?.advance_payment[0]?.reference_number}
                                        />
                                        <DivLayout
                                            heading={localization.advPaymentDate}
                                            data={viewMaterialDetails?.advance_payment[0]?.adv_payment_date}
                                        />
                                        <DivLayout
                                            heading={localization.status}
                                            data={viewMaterialDetails?.advance_payment[0]?.status}
                                        />
                                        <DivLayout
                                            heading={localization.bankName}
                                            data={viewMaterialDetails?.advance_payment[0]?.bank}
                                        />
                                        <DivLayout
                                            heading={localization.paymentRemark}
                                            data={viewMaterialDetails?.advance_payment[0]?.payment_remark}
                                        />
                                        <DocumentView
                                            title={localization.attachment}
                                            attachment={viewMaterialDetails?.advance_payment[0]?.payment_document}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {viewMaterialDetails?.images &&
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">{localization.uploadedDocument}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="row">
                                        {viewMaterialDetails?.images.map((val) => {
                                           return (
                                               <>
                                                   {val?.url !== "" && val?.url !== null && <div className="col-md-4">
                                                       <DocumentView
                                                           title={localization.attachment}
                                                           attachment={val?.url}
                                                       />
                                                   </div>}
                                               </>
                                           )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {viewMaterialDetails && parseInt(match.params.list_type) === 1  && parseInt(viewMaterialDetails?.approval_status) === 0 &&
                        <div className="container-fluid">
                            <div className="text-center" style={{'display':'inline-flex'}}>
                                <Button type="button" onClick={() => setStatus(1)} style={{'marginRight':'14%'}}>Approve</Button>
                                <Button type="button"  onClick={() => setStatus(2)}>Reject</Button>
                            </div>
                        </div>
                    }
                    {showModalContent &&
                        <ModalPop
                            title={localization.remark}
                            show={isModal}
                            handleModalHide={() => setIsModal(false)}
                            isLoading={isLoading}
                        >
                            <ConstantInput
                                label={localization.remark}
                                value={""}
                                type="text"
                                handleChange={(val) =>
                                    setRemarks(val)
                                }
                            />
                            <Button type="btn btn-danger" onClick={() => handleApprovalOrRejection()}>Submit</Button>
                        </ModalPop>
                    }
                </>
                :
                <p>Data not found</p>}

        </Layout>
    )
}

export default ViewListing